/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var initPeriode = getPeriodeObs();

function mapDisplay(site, url) {
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
            var data_all = xmlhttp.responseText;
            var jsonData = JSON.parse(data_all);
            var defaultButton = 'button-default-' + initPeriode;
            data = jsonData.records;
            var filter = jsonData.filter;
            getResults(initPeriode, data, site, {target: document.getElementById(defaultButton)});
            document.getElementById("map_visua_filtre").style.display = 'none';
            highlightTab(document.getElementById("filtre-aucun"), "filtre");
            if (filter !== '') {
                document.getElementById("filtre-box-" + filter).style.display = 'none';
            }

        }
    };
    xmlhttp.open("GET", url, true);
    xmlhttp.send();
}

function mapAutoComplete(name, url) {
    var http = new XMLHttpRequest();
    var params = "name=" + name;
    http.open("POST", url, true);
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");


    http.onreadystatechange = function () {//Call a function when the state changes.
        if (http.readyState === 4 && http.status === 200) {
            var all_obs = http.responseText;
            var jsonData = JSON.parse(all_obs);
            var select = document.getElementById('select-autoComplete');
            select.options.length = 0; // clear out existing items
            for (var i = 0; i < jsonData.length; i++) {
                void 0;
                var d = getNameObs(jsonData[i]);
                select.options.add(new Option(d));
            }
        }
    };
    http.send(params);
}

//        document.addEventListener ('DOMContentLoaded', function () {
//            document.getElementById("autoCompleteMap").addEventListener("keyup", function (event){
//                if(event.target.value.length > 2){
//                    console.log(event.target.value);
//                    setTimeout(function(){
//                        mapAutoComplete(event.target.value);
//                    }, 2000);
//                }
//                
//            });
//        });

var buttonFiltres = document.getElementById("button-filtres");
buttonFiltres.addEventListener("mouseover", function () {
    document.getElementById("map_visua_filtre").style.display = 'block';
});
buttonFiltres.addEventListener("mouseout", function () {
    document.getElementById("map_visua_filtre").style.display = 'none';
});

// initialize(null, null, 'noStreetView');